import * as activityIR from 'ducks/activityIR';
import { createSelector } from 'reselect';
import { formatUTCInLocal } from 'util/formatting';
import colors from 'styles/themes/colors';
import { getCodes } from 'ducks/codes';
import CodeTypes from 'ducks/codes/types';
import { DATE_TIME_FORMAT, IR_STATUSES } from 'app/types/constants';

export const eventTypeIconColor = function (eventType) {
  switch (eventType) {
    case IR_STATUSES.APPROVED:
      return 'green';
    case IR_STATUSES.NEW:
      return 'orange';
    default:
      return colors.primary;
  }
};

export const getIncidentReportItems = createSelector(
  activityIR.selectors,
  ({ items: incidentReportsMap }) => {
    const incidentReports = Object.values(incidentReportsMap);

    return incidentReports
      .sort((first, second) => first.creationDate > second.creationDate)
      .map((item) => {
        return {
          irNumber: item.irNumber,
          iconName: 'clipboard',
          eventTypeIcon: 'clipboard',
          eventTypeColor: eventTypeIconColor(item.status),
          incidentTitle: item.incidentTitle,
          incidentTypeTitles: item.incidentTypeTitles,
          incidentTypeIDs: item.incidentTypeIDs,
          eventTime: formatUTCInLocal(item.incidentDate, DATE_TIME_FORMAT),
          client: item.clientName,
          site: item.siteName,
          siteId: item.siteId,
          clientId: item.clientId,
          authorName: item.authorName,
          authorId: item.authorId,
          authorPosition: item.authorPosition,
          supervisorID: item.supervisorID,
          supervisorName: item.supervisorName,
          supervisorPosition: item.supervisorPosition,
          userApproved: item.userApproved,
          userApprovedName: item.userApprovedName,
          userApprovedPosition: item.userApprovedPosition,
          reportId: item.reportId,
          employee: item.employee,
          status: item.status,
          approved: item.status === IR_STATUSES.APPROVED,
          new: item.status === IR_STATUSES.NEW,
        };
      });
  }
);

export const getCategories = createSelector(
  (state) => getCodes(state, CodeTypes.INCIDENT_TYPES),
  (codes) => {
    return codes?.map(({ id: key, description: label }) => ({
      key,
      label,
    }));
  }
);
